import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

// import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
// import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import IconButton from '@mui/material/IconButton';
import MenuOutlined from '@mui/icons-material/MenuOutlined';
import style from './topnav.module.scss';
import { ProfileBar } from '../../profilebar/ProfileBar';
import LanguageSwitcher from '../../languageSwitcher/LanguageSwitcher';

const TopBar = styled('nav')({
  minHeight: '64px'
});

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    display: 'none'
  }
}));

export function Topnav({ onMenuPress = () => {}, drawerOpen }) {
  const [selectedLanguage, setSelectedLanguage] = useState('English');

  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
  };

  return (
    <TopBar className={`${style.topnav_grid_item} d-flex sticky-top`}>
      <div className="container-fluid m-0 p-0">
        <div className="row">
          <div className="col">
            {!drawerOpen ? (
              <StyledIconButton className={`${style.menu}`} onClick={onMenuPress}>
                <MenuOutlined />
              </StyledIconButton>
            ) : null}
            {/* <input className={style.search_bar} type="search" placeholder='Search..' /> */}
          </div>
          {/* commented out for release 1 */}
          {/* <div className="col text-center align-self-center">
            <Link to='/dashboard' className={style.icon}>
              <HomeOutlinedIcon sx={{ fontSize: 30 }} />
            </Link>
          </div> */}
          <div className="col">
            <div className={`${style.rs_icons} justify-content-end d-flex align-items-center`}>
              <Link to="/dashboard" className={`${style.icon} ${style.home_link}`}>
                <HomeOutlinedIcon sx={{ fontSize: 30 }} />
              </Link>
              {/* commented out for release 1 */}
              {/* <Link to='#' className={style.icon}>
                <NotificationsNoneOutlinedIcon sx={{ fontSize: 30 }} />
              </Link>
              <Link to='#' className={style.icon}>
                <HelpOutlineOutlinedIcon sx={{ fontSize: 30 }} />
              </Link> */}
              <div className={`me-3 ${style.language_switcher}`}>
                <LanguageSwitcher />
              </div>
              <div className={style.profile}>
                <ProfileBar />
              </div>
            </div>
          </div>
        </div>
      </div>
    </TopBar>
  );
}
